import React from 'react';
import { Switch, Route } from 'react-router-dom-v5';
import { publicRoutes } from '@/src/core/routes';

export const PublicRoutes = () => {
  return (
    <Switch>
      {publicRoutes.map(({ path, component: Component, exact }) => (
        <Route key={path} path={path} exact={exact}>
          <Component />
        </Route>
      ))}
    </Switch>
  );
};
